<template>
	<div  style="margin: 10px;overflow: auto;">
		<div>
			<span style="color:red;">{{message}}</span>
			<div class="inputItemDiv viewItemDiv">
				<div class="inputTitleDiv viewTitleDiv" style="margin-right: 10px;">タイトル</div>
				<div class="viewSendMail">{{mailSendHistory.title}}</div>
			</div>
			<br>
			<div class="inputItemDiv viewItemDiv">
				<div class="inputTitleDiv viewTitleDiv" style="margin-right: 10px;">本文</div>
				<div class="viewAreaSendMail">{{mailSendHistory.message}}</div>
			</div>
			<br>


			<div class="inputItemDiv viewItemDiv">
				<div class="inputTitleDiv viewTitleDiv" style="margin-right: 10px;">送信結果</div>
				<div class="inputItemDiv" v-if="errorMailList.length != 0" >以下のアドレスは送信エラーとなりました。</div>
				<div class="inputItemDiv" v-else >正常終了</div>
			</div>
			
			<div class="inputItemDiv viewItemDiv">
				<div class="inputTitleDiv viewTitleDiv" style="margin-right: 10px;background:white"></div>
				<div>
				<div class="inputItemDiv" v-for="(data) in errorMailList" :key="data.id">{{data.mail}}</div>
				</div>
			</div>
			<br>
			<div style="width:100%; text-align:center;">
				<button  type="button" class="button" @click='close()'>閉じる</button>
				<button :disabled="resAllVal"  type="button" class="button" @click='changeDealStatus'>{{dealBtnValue}}</button>
			</div>

		</div>
		

	</div>

</template>


<script>

import { ref, computed } from 'vue'
import sendMailRepository from '../composables/SendMailRepository'

export default ({
  name: 'ViewMailHistory',
  props:{
    id:String,
  },
  setup( props, context ){
    const fileName = ref("ファイルA")
    const errorMailList = ref([])
    const mailSendHistory= ref({title:"", message:"", registdate:"", status:"", progress:"", sendMailHistoryDetailList:[]})
    const message = ref("")
    
    const { getSendMailHistoryById, updateStatus } = sendMailRepository()
    
    //データ取得時のコールバック
    const callback = ( result, data )=>{
      if( result != "success"){
        context.emit( 'setMessage', result )
      }else{
        mailSendHistory.value = data
        
        errorMailList.value = mailSendHistory.value.sendMailHistoryDetailList
      }
    }
    
    //メール送信履歴データ取得
    if( props.id != null ){
      getSendMailHistoryById( props.id, callback )
    }
    
    
    const callbackChangeStatus = ( result, id, status )=>{
       if( result != "success"){
        context.emit( 'setMessage', result )
      }else{
        mailSendHistory.value.status = status
        context.emit( 'changeStatus', id, status )
        message.value = mailSendHistory.value.status == 2 ? "未対応に更新しました。" : "対応済に更新しました。";
      }
    }
    
    const dealBtnValue  = computed( ()=> {
        return mailSendHistory.value.status == 2 ? "対応済" : "未対応"
    } )
    
    const changeDealStatus = () =>{
      updateStatus( mailSendHistory.value.id, ( mailSendHistory.value.status == 2 ? 3 : 2 ), callbackChangeStatus )
    }
    
    const close = () =>{
      context.emit( 'setIsDetailView', false )
    }
    
    return{
      fileName,
      errorMailList,
      mailSendHistory,
      changeDealStatus,
      dealBtnValue,
      close,
      message
    }
  }
 })
</script>